import { eventBus, EventBusEvents } from "@/eventBus"
import { NotificationType } from "@/enums/NotificationType"

let checkoutValidationMixin = {
    computed: {
        cartTotal() {
			return this.$store.getters.totalCheckoutPrice
		},
		isCheckoutPage() {
			return this.$route.meta.isCheckout == true
		},
        isResidential() {
            return this.$store.getters.isResidential
        }
    },
    methods: {
        cartMinimumNotMet() {
            const price = this.$store.getters.price
            const min_amount = this.$store.getters.minimumOrderAmount
            return price < min_amount || this.$store.getters.itemsInCartCount < 1
        },
        requireFoodProducts() {
            return this.$store.getters.cartHasOnlyAlcohol
        },
        handleCartValidationFailed(e) {
            const errorMsg = e.message
                ? "Something went wrong, please try again."
                : e
            this.bugsnag.notify(
                "Cart Validation Failed",
                event => {
                    event.addMetadata("error", {
                        message: errorMsg
                    })
                }
            )
            this.$store.dispatch("sendMixpanelEvent", {
                msg: "Cart Validation Failed"
            })
            eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
                message: errorMsg,
                type: NotificationType.ERROR
            })
        },
        async validateCartMinimum() {
            if (this.cartMinimumNotMet()) {
                this.$store.dispatch("sendMixpanelEvent", {
                    msg: "App Minimum Alert"
                })
                const minimumMsg =
                    this.$store.getters.itemsInCartCount >= 1
                        ? `Delivery minimum is $${this.$store.getters.minimumOrderAmount}`
                        : "Your cart is empty"
                eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
                    message: minimumMsg,
                    type: NotificationType.ERROR
                })
                throw minimumMsg
            }
            return true
        },
        async validateCart() {
            try {
                if (this.requireFoodProducts()) {
                    this.$store.dispatch("sendMixpanelEvent", {
                        msg: "App Alcohol Only Alert"
                    })
                    throw "We’re required to sell food with alcohol. Add a food item to proceed with your order!"
                }
                return true
            } catch(e) {
                this.handleCartValidationFailed(e)
                throw e
            }
        }
    }
}

export default checkoutValidationMixin